import { useMemo } from 'react';
import { getAffiliateData, setAffiliateCookie } from 'js/utils/affiliate.util';

export const useAffiliatePublicAPI = () => {

    return useMemo(() => ({
        /**
         * Retrieve an object with affiliate data.
         * @memberOf Playtech.API.affiliate
         * @function
         * @param {string} [cookieName = 'banner_domainclick'] If unset, banner_domainclick cookie is used.
         * @returns {Object} {advertiser: string, bannerid: string, profileid: string, refererurl: string, creferer: string}
         * @example
         * Playtech.API.affiliate.getAffiliateData('cookieName');
         */
        getAffiliateData,
        /**
         * Set a cookie with affiliate data.
         * @memberOf Playtech.API.affiliate
         * @function
         * @param {Object} options Source of cookie to be set.
         * @param {string} [options.advertiser]
         * @param {string} [options.bannerid]
         * @param {string} [options.profileid]
         * @param {string} [options.refererurl]
         * @param {string} [options.creferer]
         * @param {string} [cookieName = 'banner_domainclick'] If unset, banner_domainclick cookie is used.
         * @example
         * Playtech.API.affiliate.setAffiliateCookie(
         *       {
         *          advertiser: 'advertiser',
         *          bannerid: 'bannerid',
         *          profileid: 'profileid',
         *          refererurl: 'refererur',
         *          creferer: 'creferer'
         *       },
         *       'cookieName'
         *);
         */
        setAffiliateCookie
    }), []);
};
